const SITE_URL = "https://www.navi-sci.cn";
const DEFAULT_IMAGE = `${SITE_URL}/favicon.ico`;

const DEFAULT_SEO = {
  title: "纳微创新",
  description:
    "纳微创新科研检测一站式服务平台，提供材料表征检测、SEM检测、成份检测、力学检测、微观检测等科研检测服务。",
  keywords:
    "纳微创新,科研检测,材料表征检测,SEM检测,成份检测,力学检测,微观检测,实验室检测",
};

const HOME_SEO = {
  title: "纳微创新 - 科研检测一站式服务 | 材料表征_SEM_成份_力学_微观检测",
  description:
    "纳微创新是一家专业的科研检测一站式服务供应商，提供材料表征检测及认证、SEM检测、成份检测、力学检测、微观检测等企业研发检验检测服务。品质保证，服务全国。",
  keywords:
    "材料表征检测,SEM检测,成份检测,力学检测,微观检测,科研检测,实验室检测,企业研发检测",
};

const ORGANIZATION = {
  "@type": "Organization",
  name: "纳微创新",
  url: `${SITE_URL}/`,
  description: "科研检测一站式服务供应商",
  image: DEFAULT_IMAGE,
  logo: DEFAULT_IMAGE,
  telephone: "400-168-0661",
  email: "hnnavi@navi-sci.cn",
  address: {
    "@type": "PostalAddress",
    addressCountry: "CN",
    addressRegion: "湖南省",
    addressLocality: "长沙市",
    addressSubLocality: "岳麓区",
    streetAddress: "岳麓街道科技创意园8栋负一楼",
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      contactType: "customer service",
      telephone: "400-168-0661",
      email: "hnnavi@navi-sci.cn",
      areaServed: "CN",
      availableLanguage: ["zh-CN"],
    },
  ],
};

function upsertMetaByName(name, content) {
  let element = document.head.querySelector(`meta[name="${name}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function upsertMetaByProperty(property, content) {
  let element = document.head.querySelector(`meta[property="${property}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let element = document.head.querySelector(`link[rel="${rel}"]`);

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
}

function upsertStructuredData(id, data) {
  let element = document.getElementById(id);

  if (!element) {
    element = document.createElement("script");
    element.id = id;
    element.type = "application/ld+json";
    document.head.appendChild(element);
  }

  element.textContent = JSON.stringify(data);
}

function getPageUrl(route) {
  if (!route || !route.path || route.path === "/") {
    return `${SITE_URL}/`;
  }

  return `${SITE_URL}${route.path}`;
}

function getSeoConfig(route) {
  const isHome = !route || route.path === "/";

  if (isHome) {
    return {
      ...DEFAULT_SEO,
      ...HOME_SEO,
      url: `${SITE_URL}/`,
      pageName: HOME_SEO.title,
      pageDescription: HOME_SEO.description,
    };
  }

  return {
    ...DEFAULT_SEO,
    title: `${DEFAULT_SEO.title} | 科研检测一站式服务平台`,
    url: getPageUrl(route),
    pageName: DEFAULT_SEO.title,
    pageDescription: DEFAULT_SEO.description,
  };
}

export function applyRouteSeo(route) {
  const seo = getSeoConfig(route);

  document.documentElement.setAttribute("lang", "zh-CN");
  document.title = seo.title;

  upsertMetaByName("description", seo.description);
  upsertMetaByName("keywords", seo.keywords);
  upsertMetaByName("robots", "index, follow");
  upsertMetaByName("author", "纳微创新");
  upsertMetaByName("copyright", "纳微创新");
  upsertMetaByName("twitter:card", "summary_large_image");
  upsertMetaByName("twitter:title", seo.title);
  upsertMetaByName("twitter:description", seo.description);
  upsertMetaByName("twitter:image", DEFAULT_IMAGE);

  upsertMetaByProperty("og:type", "website");
  upsertMetaByProperty("og:title", seo.title);
  upsertMetaByProperty("og:description", seo.description);
  upsertMetaByProperty("og:url", seo.url);
  upsertMetaByProperty("og:site_name", "纳微创新");
  upsertMetaByProperty("og:image", DEFAULT_IMAGE);
  upsertMetaByProperty("og:locale", "zh_CN");

  upsertLink("canonical", seo.url);

  upsertStructuredData("navi-sci-structured-data", {
    "@context": "https://schema.org",
    "@graph": [
      ORGANIZATION,
      {
        "@type": "WebSite",
        name: "纳微创新",
        url: `${SITE_URL}/`,
        inLanguage: "zh-CN",
      },
      {
        "@type": "WebPage",
        name: seo.pageName,
        url: seo.url,
        description: seo.pageDescription,
        inLanguage: "zh-CN",
      },
    ],
  });
}
